module.exports = __webpack_public_path__ + "img/one-gate.67d8d481.png";